import { FC } from 'react';

interface Props {
  title: string;
}

export const PageTitle: FC<Props> = ({ title }) => {
  return (
    <div className="absolute pl-0 w-full pointer-events-none">
      <div className="heading-03 w-[768px] mx-auto">{title}</div>
    </div>
  );
};
